// Hawthorn & Holly sticky add to cart (phones). Mirrors the real submit button; never adds to cart itself.
(() => {
  const bar = document.querySelector('[data-hh-sticky-cart]');
  if (!bar) return;
  const sectionId = bar.dataset.sectionId;
  const realButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
  if (!realButton) return;
  // Dawn animates the product column with a transform, which would pin a fixed bar to that column.
  document.body.appendChild(bar);
  const stickyButton = bar.querySelector('[data-hh-sticky-add]');
  const priceEl = bar.querySelector('[data-hh-sticky-price]');
  const detailEl = bar.querySelector('[data-hh-sticky-detail]');
  const priceRoot = document.getElementById(`price-${sectionId}`);
  const mobile = window.matchMedia('(max-width: 749px)');
  const onScreen = () => {
    const rect = realButton.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  };
  let realButtonOnScreen = onScreen();

  const consentBannerOpen = () => {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner) return false;
    const style = getComputedStyle(banner);
    return style.display !== 'none' && style.visibility !== 'hidden' && banner.getBoundingClientRect().height > 0;
  };

  const sync = () => {
    const current = priceRoot && priceRoot.querySelector('.price--on-sale .price-item--sale, .price:not(.price--on-sale) .price-item--regular');
    if (current && current.textContent.trim()) priceEl.textContent = current.textContent.trim();
    // Dawn can briefly hold two pickers with this id while it swaps variants; read the first.
    const picker = document.getElementById(`variant-selects-${sectionId}`);
    const options = picker ? [...picker.querySelectorAll('input:checked, select')].map((option) => option.value).filter(Boolean) : [];
    if (options.length) detailEl.textContent = `${options.join(' / ')} · £5.99 UK delivery`;
    stickyButton.disabled = realButton.disabled;
    stickyButton.textContent = realButton.querySelector('span') ? realButton.querySelector('span').textContent.trim() : realButton.textContent.trim();
  };

  const update = () => {
    const show = mobile.matches && !realButtonOnScreen && !consentBannerOpen();
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    stickyButton.tabIndex = show ? 0 : -1;
  };

  new IntersectionObserver((entries) => {
    realButtonOnScreen = entries[0].isIntersecting;
    update();
  }).observe(realButton);

  new MutationObserver(() => { sync(); update(); }).observe(realButton, { attributes: true, childList: true, subtree: true });
  if (priceRoot) new MutationObserver(sync).observe(priceRoot, { childList: true, subtree: true, characterData: true });
  document.addEventListener('change', (event) => {
    if (event.target.closest(`#variant-selects-${sectionId}`)) setTimeout(sync, 0);
  });

  // The consent banner owns the bottom of the screen until it is answered. It can appear after load.
  let bannerSeen = false;
  let ticks = 0;
  const bannerWatch = setInterval(() => {
    const open = consentBannerOpen();
    if (open) bannerSeen = true;
    update();
    ticks += 1;
    if ((bannerSeen && !open) || ticks > 40) clearInterval(bannerWatch);
  }, 700);

  stickyButton.addEventListener('click', () => {
    if (realButton.disabled) return;
    realButton.click();
  });

  window.addEventListener('scroll', () => { realButtonOnScreen = onScreen(); update(); }, { passive: true });
  mobile.addEventListener('change', update);
  sync();
  update();
})();
